module.exports = __webpack_public_path__ + "img/4-1.5d52e2b7.png";